var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useCallback, useEffect, useState } from "react";
import chatSocketConnection from "../sockets/chat.socket";
import { getDataFromStorage } from "../libs/auth.helper";
import EventEmitter from "../utils/EventEmitter";
import useConfig from "../hooks/use-config";
import { getUserInfo } from "../utils/chat.utils";
import AppConfig from "../app-config";
import { sendMessageFromPlatformEvent } from "../utils/onAuthenticationQueuedEvents";
const SocketContext = React.createContext({
    socket: null,
    initialChat: () => {
        return new Promise(() => {
        });
    },
    loadChats: (type) => {
        return new Promise(() => {
        });
    },
    addMessageToQueue: () => { },
    isConnectionFailed: false,
});
let chatSocket = null;
export const generateRoomId = (postId, ownerId, userId) => `${postId}-${ownerId}-${userId}`;
export const SocketContextProvider = (props) => {
    const [socket, setSocket] = useState(null);
    const [isConnectionFailed, setIsConnectionFailed] = useState(false);
    const [queuedMessage, setQueueMessage] = useState();
    const config = useConfig();
    const [isOnline, setIsOnline] = useState((typeof navigator !== 'undefined') && navigator && navigator.onLine);
    const sendQueuedMessage = useCallback((chatDetails) => {
        var _a, _b, _c, _d;
        if (!socket)
            return;
        let data = {
            oid: chatDetails.oid,
            pid: chatDetails.pid,
            uid: chatDetails.uid,
            post_img: chatDetails.post_img,
            post_title: chatDetails.post_title,
            post_country: chatDetails.post_country,
            post_type: (_a = chatDetails.post_type) !== null && _a !== void 0 ? _a : "default",
            sender_id: chatDetails.sender_id,
            recipient_id: chatDetails.recipient_id,
            recipient_name: chatDetails.recipient_name,
            recipient_avatar: chatDetails.recipient_avatar,
            sender_avatar: chatDetails.sender_avatar,
            sender_name: chatDetails.sender_name,
            status: (_b = chatDetails.status) !== null && _b !== void 0 ? _b : 0,
            text: chatDetails.text,
            type: (_c = chatDetails.type) !== null && _c !== void 0 ? _c : 30,
            subType: (_d = chatDetails.subType) !== null && _d !== void 0 ? _d : 300
        };
        socket === null || socket === void 0 ? void 0 : socket.emit('send', chatDetails.pid, chatDetails.oid, chatDetails.uid, data, function (mid, sent_at) {
        });
    }, [socket]);
    useEffect(() => {
        const handleStatusChange = () => {
            setIsOnline(navigator.onLine);
        };
        window.addEventListener('online', handleStatusChange);
        window.addEventListener('offline', handleStatusChange);
        return () => {
            window.removeEventListener('online', handleStatusChange);
            window.removeEventListener('offline', handleStatusChange);
        };
    }, []);
    useEffect(() => {
        if (queuedMessage && socket) {
            sendQueuedMessage(queuedMessage);
            setQueueMessage(undefined);
        }
    }, [queuedMessage, socket]);
    useEffect(() => {
        setIsConnectionFailed(!isOnline || (socket === null));
        if (config.isLoggedIn === false || socket) {
            return;
        }
        chatSocket = null;
        initialChat();
        return () => {
            chatSocket === null || chatSocket === void 0 ? void 0 : chatSocket.off('connect');
            chatSocket === null || chatSocket === void 0 ? void 0 : chatSocket.off('disconnect');
            chatSocket === null || chatSocket === void 0 ? void 0 : chatSocket.off('error');
            socket === null || socket === void 0 ? void 0 : socket.io.disconnect();
            socket === null || socket === void 0 ? void 0 : socket.disconnect();
        };
    }, [socket, isOnline, config.isLoggedIn]);
    const getToken = () => __awaiter(void 0, void 0, void 0, function* () {
        //here is the function
        // return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdDAiOjE2OTIwMDI4MzcsImF1ZCI6ImRlc2t0b3AiLCJzdWIiOjY3NTg1MjQwLCJybmQiOiI3MTAwMiIsImV4cCI6MTY5MjE4MzEyOH0.6GtUzVzJ-rfUfiuId1vHhCk5yW_OMAw9lvfeMDz6X14'
        return yield config.actions.getToken();
    });
    const fireAuthentication = () => new Promise((resolve) => getToken().then((token) => {
        var _a;
        const authData = {
            id: parseInt(((_a = getDataFromStorage().userInfo.id) === null || _a === void 0 ? void 0 : _a.toString()) || ''),
            token: token,
            platform: getDataFromStorage().source,
            country: getDataFromStorage().country,
            lang: AppConfig.getConfig().lang,
            name: getUserInfo().shopName ? getUserInfo().shopName : getUserInfo().full_name,
            avatar: getUserInfo().profile_picture,
        };
        chatSocket.emit('authentication', authData, function (...data) {
            sendMessageFromPlatformEvent();
            resolve(true);
            setIsConnectionFailed(false);
        });
    }));
    const initialChat = () => {
        if (config.isLoggedIn === false)
            return;
        chatSocket = chatSocketConnection(config.urls.chat);
        chatSocket.on('reconnect', function () {
            // setSocket(null)
            // fireAuthentication().then(() => {
            //     console.log('reconnect auth')
            //     setSocket(chatSocket)
            // })
        });
        chatSocket.on("connect", function () {
            console.log('connect');
            setSocket(null);
            fireAuthentication().then(() => {
                console.log('connect auth');
                setSocket(chatSocket);
            });
        });
        chatSocket.on("connect_timeout", function () {
            console.log('connect_timeout');
        });
        chatSocket.on("reconnect_attempt", function () {
            console.log('reconnect_attempt');
        });
        chatSocket.on("reconnect_error", function () {
            console.log('reconnect_error');
        });
        chatSocket.on("reconnect_failed", function () {
            console.log('reconnect_failed');
        });
        chatSocket.on("removeListener", function () {
            console.log('removeListener');
        });
        chatSocket.on('disconnect', function (err) {
            console.log("disconnect");
            setSocket(null);
            setIsConnectionFailed(true);
        });
        chatSocket.on('error', function (err) {
            console.log("error");
            setSocket(null);
            setIsConnectionFailed(true);
        });
        chatSocket.on("connect_error", (error) => {
            console.log("connection error");
            setSocket(null);
            setIsConnectionFailed(true);
        });
    };
    useEffect(() => {
        if (!socket)
            return;
        socket === null || socket === void 0 ? void 0 : socket.on('message', (pid, oid, uid, message, setUpChat) => {
            EventEmitter.emit("message", {
                pid,
                uid,
                message,
                setUpChat
            });
        });
        socket.on("typing", (postId, ownerPostId, userId) => {
            const roomId = generateRoomId(postId, ownerPostId, userId);
            EventEmitter.emit("typing", roomId);
        });
        return () => {
            socket === null || socket === void 0 ? void 0 : socket.off('message');
            socket === null || socket === void 0 ? void 0 : socket.off('typing');
        };
    }, [socket]);
    const loadChats = useCallback((type) => {
        if (!socket)
            return;
        socket === null || socket === void 0 ? void 0 : socket.emit('history-flat-rooms', {
            type: type,
            limit: 1000
        }, function (data) {
            EventEmitter.emit('history-rooms', data);
        });
    }, [socket]);
    const addMessageToQueue = useCallback((chatDetails) => {
        setQueueMessage(chatDetails);
    }, []);
    return (React.createElement(SocketContext.Provider, { value: {
            socket,
            initialChat,
            loadChats,
            isConnectionFailed,
            addMessageToQueue
        } }, props.children));
};
export default SocketContext;
